/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HealthInformationParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['application', codecBoolean],
    ['database', codecBoolean],
    ['uploads', codecBoolean],
    ['broker', codecBoolean],
    ['mirrorUploads', codecBoolean, 'mirror_uploads'],
    ['tempDir', codecBoolean, 'temp_dir'],
    ['tasks', codecBoolean],
    ['autoTest', codecBoolean, 'auto_test'],
    ['limiter', codecBoolean],
    ['redis', codecBoolean],
]));
export class HealthInformation extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HealthInformationParser.decode(input).map(res => new HealthInformation(res));
    }
    static unsafeDecode(input) {
        return HealthInformation.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HealthInformationParser.encode(data);
    }
    static schema() {
        return HealthInformationParser.schema();
    }
}
